import { game } from '../main';
import { GameGrid } from './GameGrid';
import { makeImage } from '../utils/makeImage';
import { changeTexture } from '../utils/changeTexture';
import { stopTweens } from '../utils/stopTweens';
import { playSound } from '../handlers/playSound';
import { BubbleFlying } from './BubbleFlying';
import {BubbleFlyingBehaviour, FlyingBubble} from "js/Elements/BubbleFlyingBehaviour";
import {ShooterFlyingBubble} from "js/Elements/ShooterFlyingBubble";
import { GameUI } from './GameUI';

export class Shooter extends Phaser.Group {
  public onShoot = new Phaser.Signal();

  private grid: GameGrid;
  private flyingBubbles: Phaser.Group;
  private vLCur: number;
  private chancesImg: Phaser.Image[] = [];
  private ready: boolean;
  private nextBubble: ShooterFlyingBubble;
  private currentBubble: ShooterFlyingBubble | null;
  private maxLives: number;
  private chanceOnMove;

  private config;

  private isBlocking: () => boolean;

  constructor(grid: GameGrid, config: any, isBlocking: () => boolean) {
    super(game);

    this.isBlocking = isBlocking;

    this.grid = grid;

    this.position.set(config.x, config.y);

    if (game.device.desktop) {
      game.input.onDown.add(this.onInputDown, this);
    } else {
      game.input.onUp.add(this.onInputDown, this);
    }

    this.flyingBubbles = game.add.group();

    const offsetX = 38;
    const startX = (config.chances * 38) * -0.5;

    for (var i = 0; i < config.chances + 1; i++) {
      var emptyBubble = makeImage(startX + (i * offsetX), 60, '0_bubble_grey', 0.5, this);
      emptyBubble.scale.setTo(0.75);
      this.chancesImg.push(emptyBubble);
    }

    const colorsAvailable = this.grid.getAllColorsOnBoard();
    console.log(colorsAvailable)

    this.nextBubble = new ShooterFlyingBubble(this.grid).init(this.x + startX, this.y + 60, game.rnd.pick(colorsAvailable))
    this.nextBubble.scale.setTo(0.75);
    this.currentBubble = new ShooterFlyingBubble(this.grid).init(this.x, this.y, game.rnd.pick(colorsAvailable));

    this.flyingBubbles.addMultiple([this.currentBubble, this.nextBubble]);

    this.ready = true;

    // G.sb('onWindowOpened').add(function() {
    //   this.windowOpened = true;
    // }, this);
    // G.sb('onAllWindowsClosed').add(function() {
    //   this.windowOpened = false;
    //   this.windowJustClosed = true;
    // }, this);
    // G.sb("onContinuePopupOpened").add(function() {
    //   this.continueOpened = true;
    // }, this);
    // G.sb("onContinuePopupClosed").add(function() {
    //   this.continueOpened = false;
    // }, this);
    this.config = config;
    this.vLCur = config.chances;
    this.maxLives = config.chances;
    this.chanceOnMove = this.maxLives;
  }

  public update(): void {
    if (this.isBlocking()) return;
    if (this.isPointerOverField()) {
      if (this.currentBubble) {
        this.currentBubble.setShootAngle(Phaser.Math.radToDeg(
          Phaser.Math.angleBetween(this.x, this.y, game.input.activePointer.worldX, game.input.activePointer.worldY)
        ));
      }
    }
  }

  private isPointerOverField(pointer?: Phaser.Pointer): boolean {
    return this.grid.gridFiledRect.contains(game.input.activePointer.worldX, game.input.activePointer.worldY)
  }

  private isReadyToShoot(): boolean {
    return !this.isBlocking() && !!this.currentBubble && this.currentBubble.scale.x == 1 && this.ready;
  }

  private onInputDown = () => {
    if (game.paused) return;

    // if (!game.device.desktop && this.windowJustClosed) {
    //   this.windowJustClosed = false;
    //   return;
    // }

    if (this.isPointerOverField() && this.isReadyToShoot()) {

      const {worldX, worldY} = game.input.activePointer;
      this.currentBubble!.setShootAngle(Phaser.Math.radToDeg(Phaser.Math.angleBetween(this.x, this.y, worldX, worldY)));
      this.onShoot.dispatch(this.currentBubble);
      this.currentBubble = null;

      this.ready = false;

      playSound('shoot_bubble');
      // sdkHandler.trigger("gameTracking", {
      //   event: "Design",
      //   dimension1: "ShootPressed"
      // });
    }
  }

  public onMoveDone(success: boolean): void {
    
    if (!success) {

    if (this.vLCur > 0) {
        this.vLCur--;
        game.add.tween(this.chancesImg[this.vLCur + 1].scale).to({
          x: 0,
          y: 0
        }, 200, Phaser.Easing.Linear.None, true);
      } else {
        this.chanceOnMove--;
        if (this.chanceOnMove < 1){
          this.chanceOnMove = this.config.chances;
        }
        this.vLCur = this.chanceOnMove;

        for (var i = 0; i <= this.vLCur; i++) {
          game.add.tween(this.chancesImg[i].scale).to({
            x: 0.75,
            y: 0.75
          }, 200, Phaser.Easing.Linear.None, true);
        }
        for (var i = this.maxLives + 1; i <= this.maxLives; i++) {
          game.add.tween(this.chancesImg[i].scale).to({
            x: 0,
            y: 0
            }, 200, Phaser.Easing.Linear.None, true); // hide lost lives
        }
        game.time.events.add(Phaser.Timer.SECOND * 0.2, this.grid.makeRefill, this.grid);
      }

    }

    if (!game.config.gameOver) {
      this.getNextBubble();
    }
  }

  public changeCurrentToBomb(): void {
    const bubbleNames = game.config.bubbleNames;
    const bubble = this.currentBubble ?? this.nextBubble;
    bubble.setType(bubbleNames.indexOf('bomb'));
  }

  public getCurrentFlyingBubble() {
    return this.currentBubble;
  }

  private getNextBubble(): void {
     const colorsAvailable = this.grid.getAllColorsOnBoard();

      if (colorsAvailable.length == 0) return;

      stopTweens(this.nextBubble);

      console.log(this.nextBubble.type)
      this.currentBubble = new ShooterFlyingBubble(this.grid).init(this.x, this.y, this.nextBubble.bubbleType);
      this.flyingBubbles.addChild(this.currentBubble);
      this.currentBubble.scale.set(0);

      if (colorsAvailable.indexOf(this.nextBubble.bubbleType) === -1) {
          this.currentBubble.setType(game.rnd.pick(colorsAvailable));
      }

      game.add.tween(this.currentBubble.scale).to({
        x: 1,
        y: 1
      }, 200, Phaser.Easing.Linear.None, true);
      game.add.tween(this.nextBubble.scale).to({
        x: 0,
        y: 0
      }, 200, Phaser.Easing.Linear.None, true).onComplete.add(() => {
        this.nextBubble.setType(game.rnd.pick(colorsAvailable));
        game.add.tween(this.nextBubble.scale).to({
          x: 0.75,
          y: 0.75
        }, 200, Phaser.Easing.Linear.None, true).onComplete.add(() => {
          this.ready = true;
        })

      })
  }
}
